if (!customElements.get('lambretta-faq-accordion')) {
  class LambrettaFaqAccordion extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.lambretta-faq__item'));

      this.items.forEach((item) => {
        item.addEventListener('toggle', () => this.handleToggle(item));
      });
    }

    handleToggle(item) {
      if (!item.open) return;

      this.items.forEach((other) => {
        if (other !== item) {
          other.open = false;
        }
      });
    }
  }

  customElements.define('lambretta-faq-accordion', LambrettaFaqAccordion);
}
